<template>
  <main class="calendar resources__page-topic">
    <div class="resources__top-wrap">
      <RichRenderer :richTextData="cPage.fields?.paragraphRich" />
    </div>
  </main>
</template>
<script>
import { usePageMeta } from '@/composables/usePageMeta'

export default {
  name: 'Calendar',
  props: {
    cPage: {
      type: Object,
      required: true,
    },
  },
  setup(props) {
    const { setPageMeta } = usePageMeta()

    setPageMeta(props.cPage?.fields?.pageMeta)
  },
}
</script>
